<app-admin-student-platform-header></app-admin-student-platform-header>

<section class="user-management" (click)="closeMenus()">
  <div>
    <div class="header">
      <div>
        <h1 class="page-title">All Companies</h1>
        <p class="subtitle">{{ total }} companies on the platform</p>
      </div>
      <button class="onboard-btn" (click)="openOnboardModal()">
        <span class="material-icons">add</span>
        Onboard Company
      </button>
    </div>

    <div class="table-wrapper">
      <div class="search-filter-row">
        <div class="search-box">
          <span class="material-icons">search</span>
          <input
            type="text"
            placeholder="Search company, contact, email..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
          />
        </div>

        <div class="filter-actions-group">
          <div class="date-filter" style="display: flex; align-items: center; gap: 8px; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; background: white; margin-right: 12px;">
            <span class="material-icons" style="color: #64748b; font-size: 20px;">calendar_today</span>
            <input
              type="date"
              [(ngModel)]="selectedDate"
              (change)="onDateChange()"
              style="border: none; outline: none; font-size: 14px; color: #1e293b; background: transparent; cursor: pointer;"
            />
            <button *ngIf="selectedDate" (click)="clearDateFilter()" style="border: none; background: transparent; cursor: pointer; display: flex; align-items: center; padding: 0;">
              <span class="material-icons" style="font-size: 16px; color: #94a3b8;">close</span>
            </button>
          </div>

          <!-- <div class="select-wrapper">
            <select
              [(ngModel)]="selectedStatus"
              (change)="onStatusChange()"
              class="filter-select"
            >
              <option value="All Status">All Status</option>
              <option value="Active">Active</option>
              <option value="Pending">Pending</option>
              <option value="Blocked">Blocked</option>
            </select>
          </div> -->

          <!-- Industry Dropdown -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedIndustry"
              (change)="onIndustryChange()"
              class="filter-select"
            >
              <option value="">All Industries</option>
              <option *ngFor="let industry of industries" [value]="industry">
                {{ industry }}
              </option>
            </select>
          </div>

          <button class="export-btn" (click)="exportToExcel()">
            <span class="material-icons">download</span>
            Export
          </button>
        </div>
      </div>

      <ng-container *ngIf="isLoading; else pageContent">
        <div class="app-spinner">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </ng-container>

      <ng-template #pageContent>
        <ng-container *ngIf="companiesData.length > 0; else showMessage">
          <div class="table-container">
            <table *ngIf="companiesData.length > 0">
              <thead>
                <tr>
                  <th>
                    <div
                      class="header-cell-sort"
                      (click)="sortBy('company_name')"
                    >
                      Company
                      <span class="material-icons sort-icon">swap_vert</span>
                    </div>
                  </th>
                  <th>CONTACT</th>
                  <th>OFFICIAL EMAIL</th>
                  <th>MOBILE</th>
                  <th>
                    <div class="header-cell-sort" (click)="sortBy('jobs')">
                      Jobs
                      <span class="material-icons sort-icon">swap_vert</span>
                    </div>
                  </th>
                  <th>STATUS</th>
                  <th>
                    <div class="header-cell-sort" (click)="sortBy('created_at')">
                      Created
                      <span class="material-icons sort-icon">swap_vert</span>
                    </div>
                  </th>
                  <th
                    class="actions-col"
                    style="text-align: right; width: 6rem"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let company of companiesData">
                  <td class="company-cell" >
                    <div class="avatar" [style.background-color]="company.logo_url ? 'transparent' : '#6366f1'">
                       <img *ngIf="company.logo_url" [src]="company.logo_url" alt="Logo" class="company-logo-img" />
                        <span *ngIf="!company.logo_url"  >
                            {{ company.company_name.substring(0, 2).toUpperCase() }}
                        </span>
                    </div>
                    <div>
                      <strong class="company-name">{{
                        company.company_name
                      }}</strong>
                      <span class="company-industry">{{ company.industry }}</span>
                    </div>
                  </td>
                  <td class="contact-cell">
                    <strong class="contact-name">{{ company.poc_name }}</strong>
                    <span class="contact-email">{{ company.poc_email }}</span>
                  </td>

                  <td>{{ company.official_email }}</td>
                  <td>{{ company.poc_phone }}</td>
                  <td style="font-weight: 500; font-size: 13px">
                    {{ company.job_count }}
                  </td>
                  <td>
                    <span
                      class="badge-dot"
                      [ngClass]="{
                        pending: company.status === 'pending',
                        approved: company.status === 'approved',
                        rejected: company.status === 'rejected',
                        blocked: company.status === 'blocked',
                      }"
                    >
                      <span class="dot"></span>
                      {{ company.status }}
                    </span>
                  </td>

                  <td>{{ company.created_at | date: "dd MMM yyyy" }}</td>

                  <td class="actions-col" style="text-align: right">
                    <div class="action-buttons-group">
                      <button
                        class="icon-action-btn"
                        (click)="
                          goToCompanyApprovalDetailPage(company.company_id)
                        "
                        matTooltip="View Details"
                      >
                        <span class="material-icons eye-icon">visibility</span>
                      </button>
                      <div class="menu-container">
                        <button
                          class="icon-action-btn"
                          (click)="toggleActionMenu($event, company.company_id)"
                          matTooltip="More Options"
                        >
                          <span class="material-icons">more_vert</span>
                        </button>

                        <div
                          class="action-dropdown"
                          *ngIf="showActionMenuId === company.company_id"
                          (click)="$event.stopPropagation()"
                        >
                          <!--<button
                            class="menu-item"
                            (click)="updateCompanyStatus(company, 'approve')"
                          >
                            <span class="material-icons menu-icon active-icon"
                              >check</span
                            >
                            Approve
                          </button>
                          <button
                            class="menu-item"
                            (click)="updateCompanyStatus(company, 'reject')"
                          >
                            <span class="material-icons menu-icon pending-icon"
                              >close</span
                            >
                            Reject
                          </button>-->
                          <button
                            class="menu-item"
                            (click)="updateCompanyStatus(company, 'block')"
                          >
                            <span class="material-icons menu-icon blocked-icon"
                              >block</span
                            >
                            Block
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-row" *ngIf="companiesData.length > 0">
            <div class="showing-text">
              Showing {{ showingFrom }} - {{ showingTo }} of {{ total }}
            </div>
            <div class="pagination-controls">
              <button
                class="pag-btn"
                [disabled]="page === 1"
                (click)="prevPage()"
              >
                <span class="material-icons">chevron_left</span>
              </button>
              <span class="page-indicator"
                >Page {{ page }} / {{ totalPages }}</span
              >
              <button
                class="pag-btn"
                [disabled]="page === totalPages"
                (click)="nextPage()"
              >
                <span class="material-icons">chevron_right</span>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #showMessage>
          <div class="no-data">
            <span class="material-icons">search_off</span>
            <h3>No companies found</h3>
            <p>Try adjusting your search query or filters.</p>
            <button class="reset-filter-btn" (click)="resetFilters()">
              <span class="material-icons">restart_alt</span> Clear Filters
            </button>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</section>

<!-- Onboard Company Modal --
<div class="modal-backdrop" *ngIf="showOnboardModal">
  <div class="modal-card">
    <button class="modal-close-btn" (click)="closeOnboardModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">Onboard New Company</h2>
    
    <div class="form-container">
      <div class="form-row">
        <div class="form-group half">
          <label class="form-label">Company Name *</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.name"
            placeholder="Nimbus Cloud"
          />
        </div>
        <div class="form-group half">
          <label class="form-label">Industry *</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.industry"
            placeholder="Cloud Infrastructure"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half">
          <label class="form-label">Contact Name *</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.contactName"
            placeholder="Rohit Sharma"
          />
        </div>
        <div class="form-group half">
          <label class="form-label">Contact Email *</label>
          <input
            type="email"
            class="form-input"
            [(ngModel)]="newCompany.contactEmail"
            placeholder="rohit@nimbus.io"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half">
          <label class="form-label">Official Email</label>
          <input
            type="email"
            class="form-input"
            [(ngModel)]="newCompany.officialEmail"
            placeholder="hr@nimbus.io"
          />
        </div>
        <div class="form-group half">
          <label class="form-label">Mobile Number</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.mobile"
            placeholder="+91 98200 11122"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half">
          <label class="form-label">Website URL</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.website"
            placeholder="https://nimbus.io"
          />
        </div>
        <div class="form-group half">
          <label class="form-label">LinkedIn URL</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.linkedin"
            placeholder="linkedin.com/company/..."
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group half">
          <label class="form-label">Locations</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="newCompany.locations"
            placeholder="Delhi, India"
          />
        </div>
        <div class="form-group half">
          <label class="form-label">Initial Active Jobs</label>
          <input
            type="number"
            class="form-input"
            [(ngModel)]="newCompany.jobs"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">About Company</label>
        <textarea
          class="form-textarea"
          rows="3"
          [(ngModel)]="newCompany.about"
          placeholder="Tell us about the company's business..."
        ></textarea>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeOnboardModal()">Cancel</button>
      <button class="btn-confirm-approve" (click)="submitOnboard()">
        Onboard Company
      </button>
    </div>
  </div>
</div>
-->
